import OrganizationInfoHeader from '../organization-info'
import ThemeBaseLogo from '../theme-base-logo'
import { useStyles } from './styles'

const UserLogoDetails = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <ThemeBaseLogo />
      <OrganizationInfoHeader />
    </div>
  )
}

export default UserLogoDetails
